module.exports = Jsw.skinUrl + "/images/sticker-collection/burst/lightning_02.png?cc7216f971c308f9f187ba73c4b12288";